module.exports = __webpack_public_path__ + "static/media/circle4.a38f6912.svg";